import { Component } from '@verndale/core';
import * as signalR from '@microsoft/signalr';

class ServerAlertBanner extends Component {
  serviceEndpoint: string;
  connection: signalR.HubConnection;

  constructor(el: HTMLElement) {
    super(el);
    this.serviceEndpoint = this.el.dataset.serviceEndpoint || '';
    Object.defineProperty(WebSocket, 'OPEN', { value: 1 });
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.serviceEndpoint, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .withAutomaticReconnect()
      .build();

    this.initConnection();
    this.addListeners();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      alertBannerContent: this.el.querySelector<HTMLElement>('.alert-banner__content'),
      link: this.el.querySelector<HTMLElement>('.alert-banner__cta-content .link.link--primary')
    };

    this.serviceEndpoint = this.el.dataset.serviceEndpoint || '';
  }

  addListeners() {}

  async initConnection() {
    try {
      this.connection.on('ReceiveAlert', (title: string, message: string) => {
        this.el.style.display = 'flex';
        (this.dom.alertBannerContent as HTMLElement).innerHTML +=
          ` <h5 class="alert-banner__title">${title} - ${message}</h5>`;
      });
      this.connection.on('ReceiveSubscribed', (title: string, message: string) => {
        this.el.style.display = 'flex';
        (this.dom.alertBannerContent as HTMLElement).innerHTML +=
          ` <h5 class="alert-banner__title">${title} - ${message}</h5>`;
      });
      await this.connection.start();
      await this.joinGroup();
    } catch (err) {
      console.error('Error establishing SignalR connection:', err);
      console.log('Connection object on error:', this.connection);
    }

    window.addEventListener('beforeunload', this.handleBeforeUnload.bind(this));
  }

  async joinGroup() {
    try {
      await this.waitForConnection();
      await this.connection.invoke('JoinGroup', 'web_main');
    } catch (err) {
      console.error('Error joining group:', err);
    }
  }

  waitForConnection() {
    return new Promise<void>((resolve, reject) => {
      const checkConnection = () => {
        if (this.connection.state === signalR.HubConnectionState.Connected) {
          resolve();
        } else if (this.connection.state === signalR.HubConnectionState.Disconnected) {
          reject(new Error('Connection is disconnected.'));
        } else {
          setTimeout(checkConnection, 100); // Check again after 100ms
        }
      };
      checkConnection();
    });
  }

  handleBeforeUnload() {
    if (this.connection && this.connection.invoke) {
      this.connection.invoke('LeaveGroup', 'web_main').catch(err => console.error(err));
    } else {
      console.error('Connection is not initialized or invoke method is not available.');
    }
  }
}

export default ServerAlertBanner;
